import { z } from 'zod';

export const movementDirectionSchema = z.enum(['IN', 'OUT', 'ADJ']);
export type MovementDirection = z.infer<typeof movementDirectionSchema>;

export const stockMovementListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  periodId: z.string().uuid().optional(),
  direction: movementDirectionSchema.optional(),
  lotId: z.string().uuid().optional(),
  productId: z.string().uuid().optional(),
  documentId: z.string().uuid().optional(),
  occurredAtFrom: z.string().datetime().optional(),
  occurredAtTo: z.string().datetime().optional(),
  // Ricerca testuale su lot.code OR product.code (LIKE case-insensitive).
  search: z.string().trim().min(1).optional(),
  // Filtro operatore esatto su StockMovement.operatorName (popolato in MPG/PSC/LNP close).
  operatorName: z.string().trim().min(1).optional(),
  format: z.enum(['json', 'xlsx']).default('json'),
});
export type StockMovementListQuery = z.infer<typeof stockMovementListQuerySchema>;

export const stockMovementResponseSchema = z.object({
  id: z.string(),
  periodId: z.string(),
  occurredAt: z.string(),
  direction: movementDirectionSchema,
  qty: z.number(),
  lotId: z.string(),
  lotCode: z.string(),
  productId: z.string(),
  productCode: z.string(),
  productName: z.string(),
  documentId: z.string().nullable(),
  documentType: z.string().nullable(),
  documentCode: z.string().nullable(),
  reason: z.string().nullable(),
  operatorName: z.string().nullable(),
});
export type StockMovementResponse = z.infer<typeof stockMovementResponseSchema>;

export const stockMovementListResponseSchema = z.object({
  items: z.array(stockMovementResponseSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type StockMovementListResponse = z.infer<typeof stockMovementListResponseSchema>;

// Aggregati su filtri (GET /api/stock-movements/aggregates).
// Tutti i campi sono espressi nella stessa unità del lotto (grammi per default
// in produzioneJB). netBalance = sumIn - sumOut + sumAdj (ADJ può essere
// positivo o negativo a seconda della rettifica INV).
export const stockMovementAggregatesQuerySchema = stockMovementListQuerySchema
  .omit({ page: true, pageSize: true, format: true });
export type StockMovementAggregatesQuery = z.infer<typeof stockMovementAggregatesQuerySchema>;

export const stockMovementAggregatesResponseSchema = z.object({
  totalCount: z.number().int().nonnegative(),
  sumIn: z.number(),
  sumOut: z.number(),
  sumAdj: z.number(),
  netBalance: z.number(),
});
export type StockMovementAggregatesResponse = z.infer<typeof stockMovementAggregatesResponseSchema>;
